
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRowingGoogle as ObiRowingGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rowing-google.js';
 
 
 

 
 export const ObiRowingGoogle = createComponent({
   react: React,
   tagName: 'obi-rowing-google',
   elementClass: ObiRowingGoogleElement,
   events: {
     
   }
  });
 
 